import './console-guard';
import App from './App.svelte';

var app = new App({
    target: document.body
});

export default app;